import { Button } from 'antd';
import React, {useEffect, useState} from 'react'
import { Redirect, useHistory } from 'react-router-dom';
import Loader from '../components/Loader';

 const CallEnded = (props) => {
    const { state } = props.history.location;
    const [roomId, setRoomid] = useState("");
    const [time, settime] = useState("");
    const [title, settitle] = useState("");
    const [datas, setData] = useState();
    const [load, setload] = useState(true);

    const [hostended, setHostended] = useState("");
    const [hostdicon, sethostdicon] = useState();

    const [host, sethost]  = useState("");

    let history = useHistory();

    useEffect(() => {
        console.log(state);
        document.title = "Call Ended"

        console.log(state);
        if(state === undefined){
            setData(false);
            setload(false);
        }
        else {
          

            setData(true);
            sethost(state.host);
            settitle(state.title)
            sethostdicon(state.hdiscon)
            setHostended(state.hostended)
            setRoomid(state.roomid);
            settime(state.duration);
            console.log(time);
            setload(false);
        }
        return () =>{
            setData(false);
            console.log('Bruh')
        };
    }, [])
    function waiting(){
history.push({
    pathname: '/WaitingRoom',
    state: {
        roomid: roomId,
        title: title,

    }
})
    }
    return (
        
        load  ? <Loader/>:
        datas ?
            <div>
           <text>{title}</text>
           <text>{time}</text>
           {host ? <text>You(Host) Ended Meeting </text>
           :
           hostended ? hostdicon ?<> 
           <text>Host Disconned</text>
           <Button onClick={() => waiting()}>Wait</Button>
            </>:<text>Host Hanguped All</text> : <text>You Just Hanged</text>}
            <button onClick={() => history.push('/')}>Go To Home</button>
            </div>
            : <Redirect to='/'></Redirect>
            
    )
}

export default CallEnded;